import { getNGOById_V2 } from "../../../Services_V2/NGO.service";
import indianNumberFormatter from "../../../utils/indian-number-formatter";
import { useEffect, useState } from "react";
import { Button, Modal } from "../../../components";
import { INGO_V2 } from "../../../types";
import styles from "./ngo-details-v2.module.css";

const NgoDetailsModal_V2 = ({
  open,
  onClose,
  ngoId,
}: {
  open: boolean;
  onClose: () => void;
  ngoId: string | null;
}) => {
  const [ngoDetails, setNgoDetails] = useState<INGO_V2 | null>(null);

  useEffect(() => {
    if (open && ngoId) {
      const fetchDetails = async () => {
        try {
          const res = await getNGOById_V2(ngoId);
          if (res?.data) {
            setNgoDetails(res.data);
          }
        } catch (error) {
          console.error(error);
        }
      };
      fetchDetails();
    } else {
      setNgoDetails(null);
    }
  }, [open, ngoId]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      showClose={true}
      modalContainerStyle={{
        maxHeight: "90vh",
        height: "auto",
        maxWidth: "480px",
      }}
    >
      <div className={styles.conatiner}>
        <div className={styles.imageContainer}>
          <img src={ngoDetails?.logo?.url} alt="ngo_image" />
        </div>
        <div>
          <h1 className={styles.name}>{ngoDetails?.name?.toUpperCase()}</h1>
          <p className={styles.description}>{ngoDetails?.tagline}</p>
        </div>
        <div className={styles.aboutUs}>
          <h4>About Us</h4>
          <p className={styles.aboutDesc}>{ngoDetails?.about}</p>
        </div>
        {/* <div className={styles.lastYearDontation}>
          <h4>Last Year Donation</h4>
          <p className={styles.aboutDesc}>
            It is the small change that makes the biggest impact.
          </p>
          <div className={styles.donationDetails}>
            <div>
              <h2>60</h2>
              <span>People</span>
              <span>Donated</span>
            </div>
            <div>
              <h2>2M</h2>
              <span>Amount</span>
              <span>Collected</span>
            </div>
          </div>
        </div> */}
        <div className={styles.lastYearDontation}>
          <h4>Donoation Details</h4>
          <p className={styles.aboutDesc}>
            It is the small change that makes the biggest impact.
          </p>
          <div className={styles.donationDetails}>
            <div>
              <h2>₹ {indianNumberFormatter(String(ngoDetails?.goal || 0))}</h2>
              <span>Goal</span>
              <span>for the year</span>
            </div>
            <div>
              <h2>
                ₹{indianNumberFormatter(String(ngoDetails?.achievedAmount || 0))}
              </h2>
              <span>Amount</span>
              <span>collected so far</span>
            </div>
          </div>
        </div>
        <Button
          fullWidth
          color="secondary"
          variant="contained"
          sx={{ mt: 4 }}
          onClick={onClose}
        >
          Close
        </Button>
      </div>
    </Modal>
  );
};

export default NgoDetailsModal_V2;
